var _circle, _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCircleCsc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uploadAccent1CSC",
    cx: 82,
    cy: 82,
    r: 82
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "uploadPrimaryBrandCSC",
    points: "69.2,89.1 71.4,91.2 81.2,81.7 81.2,115 84.3,115 84.3,81.7 94,91.2 96.2,89.1 82.7,75.9 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uploadPrimaryBrandCSC",
    d: "M61,69.8v1.5h-0.7c-7.1,0-13,5.1-14.1,11.9H46v16.4h24v-3H49V85.4l0-0.6c0.3-5.9,5.3-10.5,11.2-10.5H64v-4.5 C64,60,72.1,52,82,52c9.4,0,17.2,7.2,17.9,16.5l0.2,1.4h1.4c7.4,0,13.5,6,13.5,13.4c0,7.4-6.1,13.4-13.5,13.4H94v3h7.5 c9.1,0,16.5-7.3,16.5-16.4c0-8.6-6.7-15.6-15.2-16.3C101.3,56.8,92.5,49,82,49C70.4,49,61,58.3,61,69.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCircleCsc);
export default __webpack_public_path__ + "static/media/upload-circle-csc.f21267dd42d21d7a0a64b0ab8f272fc7.svg";
export { ForwardRef as ReactComponent };